import React from "react"
import { container } from "@components/wrapper"
import clsx from "clsx"
import { HARISENIN_PUBLIC_ICON } from "@const/pictures"
import Image from "next/image"

export function CareerInfo() {
  return (
    <section className={clsx(container, "sm:py-10", "pt-14px")}>
      <div
        className={clsx(
          "sm:flex gap-60px items-center sm:p-0 sm:bg-white",
          "p-5 bg-primary-grey rounded"
        )}
      >
        <div
          className={clsx(
            "bg-green flex flex-col justify-center sm:w-[calc(33.33%-16px)] sm:px-[56px] sm:h-[250px] lg:mb-0",
            "w-full h-[165px] px-5 mb-7"
          )}
        >
          <Image
            src={`${HARISENIN_PUBLIC_ICON}/icon_presentation.png`}
            alt="marketing"
            className="sm:h-9 h-8 w-min mb-8"
            width={200}
            height={80}
          />
          <div className="font-semibold sm:text-xl text-md text-white">Marketing</div>
        </div>

        <div
          className={clsx(
            "sm:w-2/3 sm:text-md sm:font-medium sm:leading-6",
            "w-full text-sm leading-18px"
          )}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Egestas nunc, quis arcu velit
          suspendisse adipiscing in nunc ut. Pulvinar non nisi et ac. Neque, euismod donec eu
          facilisi ac, semper enim. Sollicitudin praesent dolor commodo, varius massa. Molestie
          consectetur suspendisse quis vulputate pretium.
        </div>
      </div>
    </section>
  )
}
